<template>
	<section class="c-clients" v-if="clientLogos">
		<div class="container">
			<ul class="c-clients__list">
				<li class="c-clients__list-item"
					v-for="logo in clientLogos"
					v-if="activeFilter === 'all' ? true : (logo[activeFilter])"
					v-bind:style="'background-image:url(' + logo.url + ')'">
				</li>
			</ul>
			<div class="container" v-if="activeFilter === 'featured'">
				<a class="btn-clients" @click="showAllClients">{{ localizedMoreClientsButtonText }}</a>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: 'clients',
	props: ['filter'],
	data: () => ({
		clientsData: {},
		activeFilter: '',
		moreClientsButtonText: {
			'en-us': 'Show more clients',
			'de-ch': 'Weitere Kunden'
		}
	}),
	computed: {
		settings() {
			return this.$store.state.general.settings;
		},
		clientLogos() {
			return this.$store.state.general.clients[this.settings.currentLang]
		},
		localizedMoreClientsButtonText() {
			return this.moreClientsButtonText[this.settings.currentLang]
		}
	},
	methods: {
		showAllClients (e) {
			e.preventDefault
			this.activeFilter = 'all'
		}
	},
	mounted () {
		this.activeFilter = this.filter
	}
};
</script>

<style lang="scss">

	@import "../assets/css/helpers";

	$m: 'c-clients';

	.#{$m} {
		width: 100%;
		background-color: $colorBgGray;
		padding: 2rem 0 1rem 0;

		@include mq($from: medium) {
			padding: 4rem 0 2rem 0;
		}

		&__list {
			display: flex;
			flex-wrap: wrap;
			justify-content: space-between;
		}

		&__list-item {
			display: block;
			height: 5rem;
			width: 40%;
			margin-bottom: 2rem;
			background-size: contain;
			background-position: center;
			background-repeat: no-repeat;

			@include mq($from: medium) {
				width: calc(33.3% - .66rem);
			}
		}

		.btn-clients {
			cursor: pointer;
			border: 4px solid $colorBrandSecondary;
			display: block;
			width: 14rem;
			text-decoration: none;
			text-align: center;
			line-height: 2.5;
			margin: 1rem auto;
			font-size: .9rem;
			font-weight: 600;

			&:hover {
				border-color: $colorBrandMain;
			}
		}

	}


</style>



// WEBPACK FOOTER //
// Clients.vue?01fcbbac